<template>
  <div id="fundamentals-chart-div" style="width: 100%; height: 100%;">
    <svg id="svg-fundamentals"></svg>
  </div>
</template>

<script>
import { MacroChart } from "@/_core/charts/MacroChart";

export default {
  name: "FundamentalsChart",
  props: {
    chartData: { required: true },
    colorSelection: { required: true },
    colorTheme: { required: true, type: Boolean, default: true },
    dateFormat: { required: true },
    formatYAxis: { required: true },
    renderFundamentals: { required: true },
    selectedCountryId: { required: true },
    selectedDateId: { required: true },
  },
  data() {
    return {
      chart: null,
      logo: require("@/assets/images/symbol_blue.svg"),
      MacroChartMarkets: null,
    };
  },
  created() {
    try {
      this.MacroChartMarkets = new MacroChart(
        "fundamentals-chart-div",
        "svg-fundamentals",
        this,
      );
    } catch (error) {
      console.log(`Error calling CommodityMultiHistoricalMarkets ${error}`);
    }
  },
  watch: {
    renderFundamentals() {
      if (this.chart != null) this.chart.remove();
      this.renderChart();
    },
  },
  methods: {
    renderChart() {
      this.MacroChartMarkets.initVis(
        this.chartData,
        this.selectedDateId,
        this.selectedCountryId,
        this.colorSelection,
        this.formatYAxis,
        this.dateFormat,
        this.colorTheme,
        this.logo,
      );
    },
  },
};
</script>

<style>
.decoLines {
  stroke: var(--graylightbackground);
  stroke-width: 2;
}
.bkgrnd {
  fill: var(--lightbackground-alpha3);
}
.mainText {
  stroke: var(--transparent);
  fill: var(--transparent);
  font-size: 0.9em;
}
.mainText .hoved {
  stroke: var(--textactive);
  fill: var(--textactive);
}
.mainLines .hoved {
  fill: var(--textactive);
  fill-opacity: 1;
}
.bindLines {
  stroke: var(--lightbackground);
  stroke-width: 1;
}
.highlighted {
  fill: var(--textactive);
}
.bindLines .hoved {
  stroke: var(--textactive);
}
.sortLineOnes {
  stroke-width: 1;
}
.highlightedBind {
  stroke: var(--textactive) !important;
}
.sortLineOnes .hoved {
  stroke: var(--textactive);
}
.sortLineTwos {
  stroke-width: 1;
}
.sortLineTwos .hoved {
  stroke: var(--textactive);
}
.sortLineThrees {
  stroke-width: 1;
}
.sortLineThrees .hoved {
  stroke: var(--textactive);
}
.sortTexts {
  fill: var(--textinactive);
  font-size: 0.9rem;
}
.sortTexts .hoved {
  fill: var(--textactive);
  font-size: 1rem;
}
.highlightedText {
  fill: var(--textactive);
}

@media (max-width: 1100px) {
  .sortTexts {
    font-size: 0.9rem !important;
  }
}
/* tooltip */
/*.tooltip {*/
/*    width: 150px !important;*/
/*    line-height: 1.5;*/
/*    font-weight: 400;*/
/*    padding: 6px;*/
/*    background: var(--darkbackground) !important;*/
/*    color: var(--symmetry) !important;*/
/*    border-radius: 1px;*/
/*    pointer-events: none;*/
/*    border: 1px solid var(--lightbackground);*/
/*}*/
</style>
